export type AnimeItem = {
  id: string;
  title: string;
  subtitle: string;
  genreKey: string;
  genre: string;
  year: number;
  status: string;
  score: number;
  episodes: number;
  badge: string;
  cover: string;
  summary: string;
  tags: string[];
};

export const genres = [
  { key: "all", label: "全部" },
  { key: "rexue", label: "热血" },
  { key: "qihuan", label: "奇幻" },
  { key: "richang", label: "日常" },
  { key: "xuanyi", label: "悬疑" },
  { key: "lianai", label: "恋爱" },
  { key: "kehuan", label: "科幻" },
];

export const hotAnime: AnimeItem[] = [
  {
    id: "hot-01",
    title: "星轨追想曲",
    subtitle: "Starlane Rhapsody",
    genreKey: "kehuan",
    genre: "科幻 / 恋爱",
    year: 2025,
    status: "连载中",
    score: 9.4,
    episodes: 24,
    badge: "本季榜首",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20anime%20key%20visual%20two%20high%20school%20students%20under%20a%20giant%20glowing%20star%20map%20sky%20purple%20and%20coral%20nebula%20warm%20rim%20light%20cinematic%20composition%20detailed%20illustration%20no%20text&width=600&height=840&seq=anime-cover-h01&orientation=portrait",
    summary:
      "以近未来太空观测站为舞台，讲述两名实习领航员在一次次航行记录中逐渐建立信任的故事。叙事节奏稳定，每集以一段观测数据收束，适合喜欢科技氛围与细腻情感线的观众。",
    tags: ["太空", "成长", "群像"],
  },
  {
    id: "hot-02",
    title: "赤焰刀鸣",
    subtitle: "Crimson Blade Echo",
    genreKey: "rexue",
    genre: "热血 / 奇幻",
    year: 2025,
    status: "连载中",
    score: 9.2,
    episodes: 26,
    badge: "热度飙升",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20anime%20key%20visual%20young%20swordsman%20holding%20a%20flaming%20katana%20facing%20a%20storm%20dramatic%20orange%20and%20crimson%20lighting%20dynamic%20action%20pose%20detailed%20illustration%20no%20text&width=600&height=840&seq=anime-cover-h02&orientation=portrait",
    summary:
      "一场围绕古老锻刀世家的纷争展开，主角带着未完成的师门誓约走上历练之路。战斗作画干净利落，招式命名取自四季意象，是追求爽快战斗体验的观众的热门选择。",
    tags: ["战斗", "成长", "羁绊"],
  },
  {
    id: "hot-03",
    title: "深夜食堂物语",
    subtitle: "Midnight Diner Tales",
    genreKey: "richang",
    genre: "日常 / 治愈",
    year: 2024,
    status: "已完结",
    score: 9.0,
    episodes: 12,
    badge: "口碑之选",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20anime%20key%20visual%20cozy%20small%20night%20diner%20warm%20lantern%20light%20steaming%20bowls%20gentle%20amber%20tones%20quiet%20healing%20atmosphere%20detailed%20illustration%20no%20text&width=600&height=840&seq=anime-cover-h03&orientation=portrait",
    summary:
      "小城巷口一间只在夜里营业的食堂，每集以一道家常菜串联一位客人的心事。没有激烈的冲突，却在收尾时留下余温，非常适合当作睡前放松的补番选择。",
    tags: ["治愈", "单元剧", "美食"],
  },
  {
    id: "hot-04",
    title: "雾都异闻录",
    subtitle: "Fogbound Records",
    genreKey: "xuanyi",
    genre: "悬疑 / 推理",
    year: 2025,
    status: "连载中",
    score: 8.9,
    episodes: 20,
    badge: "悬疑新作",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20anime%20key%20visual%20detective%20in%20a%20coat%20standing%20in%20misty%20old%20town%20street%20at%20dusk%20muted%20teal%20and%20amber%20lamplight%20mysterious%20mood%20detailed%20illustration%20no%20text&width=600&height=840&seq=anime-cover-h04&orientation=portrait",
    summary:
      "常年被薄雾笼罩的口岸城市里，一桩旧案重新浮出水面。剧本以线索板式的结构推进，每集留下一个可被观众推理的小谜题，适合边看边记笔记的考据党。",
    tags: ["推理", "群像", "单元剧"],
  },
  {
    id: "hot-05",
    title: "云端跑者",
    subtitle: "Skyline Runners",
    genreKey: "rexue",
    genre: "热血 / 运动",
    year: 2024,
    status: "连载中",
    score: 8.7,
    episodes: 22,
    badge: "青春竞技",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20anime%20key%20visual%20teenage%20parkour%20runners%20leaping%20across%20rooftops%20at%20sunset%20golden%20and%20coral%20sky%20energetic%20motion%20detailed%20illustration%20no%20text&width=600&height=840&seq=anime-cover-h05&orientation=portrait",
    summary:
      "一支濒临解散的高中跑酷队，在新教练的带领下重新出发。作品用大量实景观察提炼出训练细节，主线之外还穿插了每个队员的个人目标，节奏明快且不空洞。",
    tags: ["竞技", "成长", "友情"],
  },
  {
    id: "hot-06",
    title: "花见小路",
    subtitle: "Blossom Lane",
    genreKey: "lianai",
    genre: "恋爱 / 日常",
    year: 2025,
    status: "连载中",
    score: 8.8,
    episodes: 18,
    badge: "甜度在线",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20anime%20key%20visual%20two%20teenagers%20walking%20under%20blooming%20cherry%20trees%20on%20a%20narrow%20lane%20soft%20pink%20and%20warm%20light%20romantic%20gentle%20mood%20detailed%20illustration%20no%20text&width=600&height=840&seq=anime-cover-h06&orientation=portrait",
    summary:
      "沿着一条种满花树的老街，两位青梅竹马重新认识彼此。作品把日常对话写得很大方，不靠巧合推动关系，而是用一次次并肩而行积累距离感的变化。",
    tags: ["青春", "恋爱", "日常"],
  },
  {
    id: "hot-07",
    title: "龙脊咏叹调",
    subtitle: "Dragonridge Aria",
    genreKey: "qihuan",
    genre: "奇幻 / 冒险",
    year: 2024,
    status: "已完结",
    score: 8.6,
    episodes: 25,
    badge: "史诗完结",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20anime%20key%20visual%20rider%20on%20a%20dragon%20circling%20jagged%20mountain%20peaks%20at%20dawn%20epic%20teal%20and%20gold%20palette%20sweeping%20composition%20detailed%20illustration%20no%20text&width=600&height=840&seq=anime-cover-h07&orientation=portrait",
    summary:
      "横跨三大王国的旅程，主角从一名普通牧龙人成长为调和者。世界观设定资料在每集片尾以短文形式补充，剧情收束完整，适合一口气追完的长篇爱好者。",
    tags: ["世界观", "冒险", "成长"],
  },
  {
    id: "hot-08",
    title: "第七夜航",
    subtitle: "Voyage Seven",
    genreKey: "kehuan",
    genre: "科幻 / 悬疑",
    year: 2025,
    status: "连载中",
    score: 8.5,
    episodes: 16,
    badge: "脑洞之作",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20anime%20key%20visual%20lone%20astronaut%20inside%20a%20dim%20cockpit%20looking%20at%20a%20vast%20starfield%20cold%20teal%20and%20warm%20console%20lights%20tense%20mood%20detailed%20illustration%20no%20text&width=600&height=840&seq=anime-cover-h08&orientation=portrait",
    summary:
      "一艘执行第七次深空任务的飞船，与地面失去联络后开始出现无法解释的记录差异。剧本以时间线交错的方式铺陈，观众需要留意每集开头的时间戳，属于慢热的思辨向作品。",
    tags: ["科幻", "悬念", "慢热"],
  },
];

export const lateNightAnime: AnimeItem[] = [
  {
    id: "ln-01",
    title: "午夜列车227",
    subtitle: "Train 227",
    genreKey: "xuanyi",
    genre: "悬疑",
    year: 2024,
    status: "已完结",
    score: 8.9,
    episodes: 13,
    badge: "深夜推荐",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20anime%20key%20visual%20old%20night%20train%20interior%20with%20warm%20reading%20lights%20outside%20dark%20rain%20muted%20amber%20tones%20mysterious%20calm%20mood%20detailed%20illustration%20no%20text&width=600&height=840&seq=anime-cover-l01&orientation=portrait",
    summary:
      "一趟只在午夜发车的列车载着各怀心事的乘客，每一站都对应一段往事。全程对话驱动，适合安静戴上耳机独自观看。",
    tags: ["悬疑", "单元剧"],
  },
  {
    id: "ln-02",
    title: "月下独奏",
    subtitle: "Moonlight Solo",
    genreKey: "lianai",
    genre: "恋爱 / 音乐",
    year: 2025,
    status: "连载中",
    score: 8.7,
    episodes: 12,
    badge: "深夜推荐",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20anime%20key%20visual%20girl%20playing%20a%20piano%20by%20a%20large%20window%20under%20moonlight%20cool%20teal%20and%20warm%20cream%20tones%20intimate%20calm%20mood%20detailed%20illustration%20no%20text&width=600&height=840&seq=anime-cover-l02&orientation=portrait",
    summary:
      "临海小镇的音乐教室里，两段未完成的旋律被悄悄续上。作品把练琴的反复与心境变化交织，配乐以钢琴独奏为主，夜晚观感尤佳。",
    tags: ["音乐", "青春"],
  },
  {
    id: "ln-03",
    title: "零号档案",
    subtitle: "File Zero",
    genreKey: "kehuan",
    genre: "科幻 / 悬疑",
    year: 2024,
    status: "已完结",
    score: 8.6,
    episodes: 14,
    badge: "深夜推荐",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20anime%20key%20visual%20archivist%20examining%20glowing%20holographic%20files%20in%20a%20dark%20archive%20room%20teal%20glow%20and%20amber%20accent%20cerebral%20mood%20detailed%20illustration%20no%20text&width=600&height=840&seq=anime-cover-l03&orientation=portrait",
    summary:
      "一名档案管理员在整理数据时发现了一份不存在编号的记录。故事用档案编号作为章节线索，信息量大但条理清晰。",
    tags: ["科幻", "推理"],
  },
  {
    id: "ln-04",
    title: "便利店夜班记",
    subtitle: "Night Shift Store",
    genreKey: "richang",
    genre: "日常",
    year: 2025,
    status: "连载中",
    score: 8.4,
    episodes: 12,
    badge: "深夜推荐",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20anime%20key%20visual%20bright%20convenience%20store%20interior%20at%20night%20with%20a%20clerk%20behind%20the%20counter%20warm%20fluorescent%20light%20everyday%20cozy%20mood%20detailed%20illustration%20no%20text&width=600&height=840&seq=anime-cover-l04&orientation=portrait",
    summary:
      "深夜的便利店迎来形形色色的客人，收银台成了观察人间的小窗口。每集时长友好，笑着看完刚好入睡。",
    tags: ["治愈", "日常"],
  },
  {
    id: "ln-05",
    title: "黑猫侦探社",
    subtitle: "Black Cat Agency",
    genreKey: "xuanyi",
    genre: "悬疑 / 推理",
    year: 2024,
    status: "已完结",
    score: 8.8,
    episodes: 15,
    badge: "深夜推荐",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20anime%20key%20visual%20detective%20office%20with%20a%20black%20cat%20on%20a%20desk%20warm%20lamp%20light%20and%20teal%20shadows%20cerebral%20cozy%20mood%20detailed%20illustration%20no%20text&width=600&height=840&seq=anime-cover-l05&orientation=portrait",
    summary:
      "一家只有预约才能找到的侦探社，接待的委托都带着一点超自然的边角料。案件收尾干脆，单元结构适合碎片时间观看。",
    tags: ["推理", "单元剧"],
  },
  {
    id: "ln-06",
    title: "凌晨三点的琴键",
    subtitle: "3AM Keys",
    genreKey: "lianai",
    genre: "恋爱 / 日常",
    year: 2025,
    status: "连载中",
    score: 8.5,
    episodes: 12,
    badge: "深夜推荐",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20anime%20key%20visual%20sleepless%20teen%20sitting%20at%20an%20upright%20piano%20late%20at%20night%20in%20a%20small%20room%20warm%20amber%20lamp%20and%20teal%20shadows%20quiet%20mood%20detailed%20illustration%20no%20text&width=600&height=840&seq=anime-cover-l06&orientation=portrait",
    summary:
      "总是在凌晨醒来的女孩，和一个总在深夜练琴的邻居，隔着薄墙开始了无声的交流。情感推进克制，细节耐看。",
    tags: ["青春", "治愈"],
  },
];

export const classicAnime: AnimeItem[] = [
  {
    id: "cl-01",
    title: "银河少年纪",
    subtitle: "Galaxy Boys",
    genreKey: "kehuan",
    genre: "科幻 / 冒险",
    year: 2010,
    status: "已完结",
    score: 9.1,
    episodes: 50,
    badge: "经典老番",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20retro%20anime%20key%20visual%20young%20crews%20aboard%20a%20classic%20spaceship%20bridge%20with%20warm%20console%20lights%20against%20a%20deep%20starfield%20nostalgic%20detailed%20illustration%20no%20text&width=600&height=840&seq=anime-cover-c01&orientation=portrait",
    summary:
      "一艘少年舰队横跨星海的成长史，是很多人入门科幻番的起点。单元冒险与主线危机交替推进，重看仍能发现大量伏笔。",
    tags: ["科幻", "长篇"],
  },
  {
    id: "cl-02",
    title: "风之谷传说",
    subtitle: "Valley of Winds",
    genreKey: "qihuan",
    genre: "奇幻 / 冒险",
    year: 2008,
    status: "已完结",
    score: 8.9,
    episodes: 39,
    badge: "经典老番",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20retro%20anime%20key%20visual%20traveler%20with%20a%20cloak%20crossing%20a%20green%20valley%20with%20windmills%20under%20a%20vast%20sky%20warm%20golden%20and%20teal%20palette%20nostalgic%20detailed%20illustration%20no%20text&width=600&height=840&seq=anime-cover-c02&orientation=portrait",
    summary:
      "一段关于旅人与风之约定的古老传说，画风朴素但情感厚重。适合喜欢慢节奏世界观铺陈的观众补课。",
    tags: ["奇幻", "长篇"],
  },
  {
    id: "cl-03",
    title: "夏日回声",
    subtitle: "Summer Echo",
    genreKey: "richang",
    genre: "日常 / 青春",
    year: 2011,
    status: "已完结",
    score: 8.8,
    episodes: 26,
    badge: "经典老番",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20retro%20anime%20key%20visual%20group%20of%20friends%20on%20a%20country%20road%20in%20summer%20with%20electric%20fans%20and%20sunflowers%20warm%20nostalgic%20light%20detailed%20illustration%20no%20text&width=600&height=840&seq=anime-cover-c03&orientation=portrait",
    summary:
      "一群少年在漫长暑假里的琐碎日常，被写成了温柔又漫长的告别。画面里的蝉鸣与风扇声是许多人共同的记忆。",
    tags: ["青春", "治愈"],
  },
  {
    id: "cl-04",
    title: "剑与誓约",
    subtitle: "Sword and Oath",
    genreKey: "rexue",
    genre: "热血 / 奇幻",
    year: 2009,
    status: "已完结",
    score: 8.7,
    episodes: 48,
    badge: "经典老番",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20retro%20anime%20key%20visual%20knight%20kneeling%20with%20a%20longsword%20in%20a%20stone%20hall%20warm%20torchlight%20and%20teal%20shadows%20epic%20nostalgic%20detailed%20illustration%20no%20text&width=600&height=840&seq=anime-cover-c04&orientation=portrait",
    summary:
      "以骑士团的誓约为核心的长篇热血作，战斗编排扎实，成长线清晰。是补番清单里常被提起的扎实之作。",
    tags: ["热血", "长篇"],
  },
  {
    id: "cl-05",
    title: "记忆碎片之城",
    subtitle: "City of Fragments",
    genreKey: "xuanyi",
    genre: "悬疑 / 科幻",
    year: 2012,
    status: "已完结",
    score: 8.9,
    episodes: 24,
    badge: "经典老番",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20retro%20anime%20key%20visual%20fragmented%20cityscape%20with%20floating%20shards%20and%20a%20lone%20figure%20on%20a%20rooftop%20muted%20teal%20and%20amber%20cerebral%20nostalgic%20detailed%20illustration%20no%20text&width=600&height=840&seq=anime-cover-c05&orientation=portrait",
    summary:
      "一座会遗忘居民的城市，和唯一记得全程的少女。剧本结构精巧，结局曾引发大量讨论，适合反复观看。",
    tags: ["悬疑", "科幻"],
  },
  {
    id: "cl-06",
    title: "星空列车",
    subtitle: "Starlight Express",
    genreKey: "kehuan",
    genre: "科幻 / 治愈",
    year: 2013,
    status: "已完结",
    score: 9.0,
    episodes: 20,
    badge: "经典老番",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20retro%20anime%20key%20visual%20old%20train%20traveling%20across%20a%20sea%20of%20stars%20at%20night%20warm%20carriage%20windows%20against%20cool%20nebula%20nostalgic%20detailed%20illustration%20no%20text&width=600&height=840&seq=anime-cover-c06&orientation=portrait",
    summary:
      "一列在星空轨道上行驶的列车，载着人们各自的遗憾前行。安静而治愈，是深夜补番的经典选择。",
    tags: ["治愈", "科幻"],
  },
];

export const heroStats = [
  { value: "12,860+", label: "在库作品条目", icon: "ri-film-line" },
  { value: "6,400+", label: "1080P 可下载资源", icon: "ri-download-2-line" },
  { value: "98%", label: "在线播放稳定率", icon: "ri-play-circle-line" },
  { value: "7×24", label: "深夜更新值守", icon: "ri-moon-clear-line" },
];

export const tickerItems = [
  "本季新番《星轨追想曲》第 12 集已更新",
  "《龙脊咏叹调》全集 1080P 资源上线",
  "深夜专区「凌晨三点」系列补档完成",
  "经典老番《银河少年纪》修复版可下载",
  "每周三 20:00 固定更新，追番提醒已就绪",
];

export const weeklySchedule = [
  {
    day: "周一",
    en: "MON",
    shows: [
      { title: "雾都异闻录", time: "20:00", genre: "悬疑" },
      { title: "便利店夜班记", time: "23:30", genre: "日常" },
    ],
  },
  {
    day: "周二",
    en: "TUE",
    shows: [
      { title: "云端跑者", time: "19:30", genre: "运动" },
      { title: "零号档案·补档", time: "22:00", genre: "科幻" },
    ],
  },
  {
    day: "周三",
    en: "WED",
    shows: [
      { title: "星轨追想曲", time: "20:00", genre: "科幻" },
      { title: "花见小路", time: "21:15", genre: "恋爱" },
    ],
  },
  {
    day: "周四",
    en: "THU",
    shows: [
      { title: "赤焰刀鸣", time: "20:30", genre: "热血" },
      { title: "月下独奏", time: "23:00", genre: "音乐" },
    ],
  },
  {
    day: "周五",
    en: "FRI",
    shows: [
      { title: "第七夜航", time: "21:00", genre: "科幻" },
      { title: "经典老番重制档", time: "22:30", genre: "合集" },
    ],
  },
  {
    day: "周六",
    en: "SAT",
    shows: [
      { title: "深夜马拉松·全集连播", time: "22:00", genre: "合集" },
      { title: "黑猫侦探社", time: "23:45", genre: "推理" },
    ],
  },
  {
    day: "周日",
    en: "SUN",
    shows: [
      { title: "本周新番盘点", time: "19:00", genre: "资讯" },
      { title: "花见小路·抢先看", time: "21:30", genre: "恋爱" },
    ],
  },
];

export const downloadTiers = [
  {
    id: "dl-1080",
    name: "1080P 高清收藏",
    resolution: "1920×1080",
    codec: "H.264 / AAC",
    size: "单集约 420MB",
    desc: "画质与体积的平衡之选，适合手机与平板离线观看，字幕为内嵌简繁双语。",
    accent: "primary",
  },
  {
    id: "dl-4k",
    name: "4K 超清原盘",
    resolution: "3840×2160",
    codec: "H.265 / FLAC",
    size: "单集约 1.6GB",
    desc: "面向大屏与投屏用户，保留更多暗部细节，建议使用支持 H.265 硬解的播放器。",
    accent: "accent",
  },
  {
    id: "dl-batch",
    name: "整季打包合集",
    resolution: "混合清晰度",
    codec: "按季整理",
    size: "约 8～15GB / 季",
    desc: "按季度整理成一包，文件名统一编号，方便一次性补齐正在追的整季内容。",
    accent: "secondary",
  },
];

export const guideSteps = [
  {
    step: "01",
    title: "先定追番节奏",
    desc: "打开更新表确认本周想追的作品时间，把「连载中」与「已完结」分开安排，避免同时开坑太多。",
    icon: "ri-calendar-schedule-line",
  },
  {
    step: "02",
    title: "在线看还是先下载",
    desc: "只想快速跟上进度就用在线入口；通勤或网络不稳的场景，提前在下载专区存好整季更省心。",
    icon: "ri-folder-download-line",
  },
  {
    step: "03",
    title: "按类型锁定目标",
    desc: "在类型筛选里选定偏好标签，再用关键词缩小范围，比逐条翻目录快很多，也更容易发现同题材新作。",
    icon: "ri-filter-3-line",
  },
  {
    step: "04",
    title: "建立自己的补番清单",
    desc: "把「想看」与「在看」分开记录，经典老番建议安排在周末整段休息时间，观感更完整。",
    icon: "ri-bookmark-3-line",
  },
];

export const faqs = [
  {
    q: "51动漫可以在线看，也支持下载吗？",
    a: "是的。站内条目同时提供在线观看与资源下载两种入口：在线入口适合随点随看跟进连载，下载入口则提供 1080P、4K 与整季打包等不同选项，可根据设备与网络情况自行选择。",
  },
  {
    q: "深夜追番专区和其他分区有什么不同？",
    a: "深夜专区挑出的多是节奏偏慢、以对话和氛围为主的作品，适合睡前安静观看；热门全集区更偏向高热度连载新番，更新频率更快。两者内容不重复，可以根据当下的状态切换。",
  },
  {
    q: "类型筛选和搜索会作用到全部片库吗？",
    a: "会。类型标签与关键词搜索都在本页已有的条目中实时筛选，结果即时显示，刷新页面后恢复全部内容，不会跳转到其他页面。",
  },
  {
    q: "下载清晰度该怎么选？",
    a: "手机、平板离线观看选 1080P 即可，体积轻、兼容好；使用大屏或投屏时再考虑 4K 原盘。若打算一次性补齐整季，整季打包合集在文件整理上更省事。",
  },
  {
    q: "更新表上的时间会变吗？",
    a: "更新时间为常规排期参考，遇到特别篇、停更或临时调档时会以站内通知为准。建议以「连载中」标注的条目为追更重点。",
  },
];

export const highlights = [
  {
    title: "完整片库分区",
    desc: "热门全集、深夜专区、经典老番三线并行，按观看场景而非单纯按年份归类，找片更符合实际习惯。",
    icon: "ri-layout-grid-line",
  },
  {
    title: "多档下载规格",
    desc: "从 1080P 到 4K 原盘，再到整季打包，下载专区给出明确的体积与编码说明，选择前心里有数。",
    icon: "ri-hard-drive-3-line",
  },
  {
    title: "更新节奏透明",
    desc: "每周排期以表格形式公开，连载与完结一目了然，方便提前安排属于自己的追番节奏。",
    icon: "ri-timer-flash-line",
  },
];

export const libraryMetrics = [
  { value: "12,860", unit: "部", label: "在库动漫条目" },
  { value: "3", unit: "大", label: "观看场景分区" },
  { value: "12", unit: "种", label: "清晰度与打包规格" },
  { value: "5", unit: "次", label: "每周固定更新批次" },
];

export const qualityNotes = [
  {
    title: "字幕与音轨",
    desc: "默认提供简繁双语内嵌字幕，4K 档另附独立音轨与 OP / ED 纯享版本，可按需取舍。",
    icon: "ri-closed-captioning-line",
  },
  {
    title: "播放器建议",
    desc: "H.265 编码建议使用支持硬解的播放器，老设备可优先选择 1080P 档以获得更稳定的播放体验。",
    icon: "ri-computer-line",
  },
  {
    title: "文件命名规范",
    desc: "整季包按「作品名-季数-集号-清晰度」统一命名，导入本地媒体库时可被自动识别归类。",
    icon: "ri-file-list-3-line",
  },
];